export default [
  {
    path: "/explore/:category?",
    name: "explore",
    alias: "/",
    component: () => import("../components/Explore.vue"),
    meta: {}
  }
];
